module.exports = __webpack_public_path__ + "static/media/strikethrough.9b2fc807.png";